"use client";

import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "@/app/components/ui/button";
import { Home, RefreshCw } from "lucide-react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
          <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
            <div className="relative w-52 h-52 mx-auto mb-6">
              <Image
                src="/404.svg"
                alt="Error Illustration"
                fill
                className="object-contain"
                onError={(e) => {
                  // Fallback if the SVG doesn't load
                  e.currentTarget.style.display = "none";
                }}
              />
              {/* Fallback content if image fails to load */}
              <div className="absolute inset-0 flex items-center justify-center text-8xl font-bold text-red-500 opacity-20">
                Hata
              </div>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold mb-4">Bir Sorun Oluştu</h1>
            
            <p className="text-gray-600 mb-8">
              Üzgünüz, sayfayı yüklerken bir hata ile karşılaştık.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="outline" 
                className="flex items-center gap-2"
                onClick={() => reset()}
              >
                <RefreshCw size={16} />
                Yeniden Dene
              </Button>
              
              <Button 
                className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600"
              >
                <Link href="/" className="flex items-center gap-2">
                  <Home size={16} />
                  Ana Sayfa
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
} 